export default __webpack_public_path__ + "static/media/data-storage.64b5fd05.svg";